import { useState } from 'react';
import { ViewMode } from '../components/MoldList/types';

export const useViewMode = (initialViewMode: ViewMode = 'card') => {
  const [viewMode, setViewMode] = useState<ViewMode>(initialViewMode);

  const toggleViewMode = (mode: ViewMode) => {
    setViewMode(mode);
  };

  return {
    viewMode,
    setViewMode: toggleViewMode,
  };
};
